// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-top[data-v-0bf93bfe]{position:-webkit-sticky;position:sticky;top:120px;z-index:9}@media (min-width:769px){#scrollable[data-v-0bf93bfe]{max-height:calc(100vh - 30px);overflow-y:auto;padding-top:10px;padding-bottom:20px;-ms-overflow-style:none;scrollbar-width:none}#scrollable[data-v-0bf93bfe]::-webkit-scrollbar{display:none}}", ""]);
// Exports
module.exports = exports;
